module.exports = __webpack_public_path__ + "static/media/truck-container.39165829.svg";